import React from 'react';
import { LOCKER_SIZES } from './MultiLockerSelector';

const MultiBookingSummary = ({ 
  selectedDate, 
  selectedTime, 
  hours, 
  lockerQuantities,
  showFull = false 
}) => {
  const endHour = selectedTime 
    ? String(parseInt(selectedTime.split(':')[0]) + hours).padStart(2, '0') 
    : '00';

  // Calculate totals
  const selectedLockers = LOCKER_SIZES.filter(l => (lockerQuantities[l.id] || 0) > 0);
  const totalLockersCount = Object.values(lockerQuantities).reduce((sum, qty) => sum + qty, 0);
  const pricePerHour = selectedLockers.reduce((sum, l) => sum + (l.price * (lockerQuantities[l.id] || 0)), 0);
  const totalPrice = pricePerHour * hours;

  return (
    <div className="bg-[#0A0A0A] border border-[#2A2A2A] p-4 mt-6">
      <h4 className="text-white font-semibold mb-3">
        {showFull ? 'Riepilogo Finale' : 'Riepilogo'}
      </h4>
      
      {/* Locker breakdown */}
      {selectedLockers.length > 0 && (
        <div className="space-y-2 mb-3 pb-3 border-b border-[#2A2A2A]">
          {selectedLockers.map(locker => {
            const qty = lockerQuantities[locker.id];
            const subtotal = locker.price * qty;
            return (
              <div key={locker.id} className="flex justify-between text-sm">
                <span className="text-gray-400">
                  {qty}× {locker.name} ({locker.label})
                </span>
                <span className="text-white">
                  €{subtotal.toFixed(2).replace('.', ',')}/ora
                </span>
              </div>
            );
          })}
          <div className="flex justify-between text-sm font-semibold pt-1">
            <span className="text-gray-400">Totale {totalLockersCount} locker</span>
            <span className="text-[#FFCC00]">€{pricePerHour.toFixed(2).replace('.', ',')}/ora</span>
          </div>
        </div>
      )}

      <div className="space-y-1 text-sm">
        <p className="text-gray-400">
          Data: <span className="text-white">
            {selectedDate?.toLocaleDateString('it-IT', { weekday: 'long', day: 'numeric', month: 'long' })}
          </span>
        </p>
        <p className="text-gray-400">
          Orario: <span className="text-white">
            {selectedTime} - {endHour}:00 ({hours} {hours === 1 ? 'ora' : 'ore'})
          </span>
        </p>
      </div>
      
      <div className="border-t border-[#2A2A2A] mt-3 pt-3">
        <div className="flex justify-between items-center text-sm text-gray-400 mb-1">
          <span>€{pricePerHour.toFixed(2).replace('.', ',')} × {hours}h</span>
        </div>
        <div className="flex justify-between items-center">
          <span className="text-gray-400">{showFull ? 'Totale da pagare:' : 'Totale:'}</span>
          <span className="text-[#FFCC00] text-2xl font-bold">€{totalPrice.toFixed(2).replace('.', ',')}</span>
        </div>
      </div>
    </div>
  );
};

export default MultiBookingSummary;
